export default __webpack_public_path__ + "static/hw_pir-f36c310775c8be114ee90169476d2466.jpg";